const COLOR_THEME = "colorTheme";
const colorTheme = {
  current: localStorage.getItem(COLOR_THEME),
  navbar: document.querySelector(".js-navbar"),
  color: {
    dark: "#1c1c1c",
    light: "#f5f5f5",
    transparent: "transparent",
  },
  class: {
    dark: "is-darkTheme",
    light: "is-lightTheme",
  },
};

const THEME_DARK = "dark";
const THEME_LIGHT = "light";
const COLOR_THEME_CURRENT = colorTheme.current || THEME_DARK; // You can remove forcing THEME_DARK by default if you prefer use the normal behavior
const COLOR_THEME_DARK = colorTheme.color.dark;
const COLOR_THEME_LIGHT = colorTheme.color.light;
const COLOR_THEME_TRANSPARENT = colorTheme.color.transparent;
const CLASS_THEME_DARK = colorTheme.class.dark;
const CLASS_THEME_LIGHT = colorTheme.class.light;

const NAVBAR = ".js-navbar";
const FIXEDNAV = ".js-fixedNav";
